// extracted by mini-css-extract-plugin
export default {"cls1":"B6EXu3gohe4UB4iQAPRa","cls2":"J4Mvsy_hUVlfkktB6Nz5 B6EXu3gohe4UB4iQAPRa"};